import SoundController from "../../utils/SoundController";
import Button, { IButtonSkin } from "./Button";
import { Tween } from "./../../Tween";
import { IObjectConfig } from "../../baseConfigs/layoutConfigShema";
import Layout from "../../utils/Layout";
import TextField, { ITextFieldStyleOptions } from "./TextField";
import { Texture } from "pixi.js";
import App from "../../App";

export default class SwitchButton extends Button {
    protected isOn: boolean;
    protected selectedSkinMap: any;
    protected textures: {on?: string, off?: string};
    protected selectedText: TextField;
    protected onSkins: IButtonSkin;
    protected offStateSoundId: string;

    constructor(offTextures: IButtonSkin, onTextures?: IButtonSkin  ) {
        super(offTextures );
        this.isOn = false;
        this.onSkins = onTextures;
        this.setSelectedSkins(onTextures || offTextures);
    }

    /**
     * Create an exact replica of current button at a  new position
     * @param cloneX absolute coordinate x of new button
     * @param cloneY absolute coordinate y of new button
     */
    public clone(cloneX: number, cloneY: number): SwitchButton {
        const btn = new SwitchButton(this.skins, this.onSkins);
        btn.butImg.x = Layout.scalePixels(cloneX);
        btn.butImg.y = Layout.scalePixels(cloneY);
        
        btn.setAnchor(this.butImg.anchor.x, this.butImg.anchor.y);
        Layout.testSetWidth(btn,Layout.getWidth(this));

        if (this.text) {
            const style: ITextFieldStyleOptions = this.text.initStyle;
            const tf = new TextField(
                this.text.text, 
                style,
                {
                    bound: this.repositionBounds(cloneX, cloneY),
                    anchor: this.butImg.anchor
                }
            );
            btn.addLabelTF(tf);
        }

        if (this.selectedText) {
            const style: ITextFieldStyleOptions = this.selectedText.initStyle;
            const stf = new TextField(
                this.selectedText.text, 
                style,
                {
                    bound: this.repositionBounds(cloneX, cloneY),
                    anchor: this.butImg.anchor
                }
            );
            btn.addSelectedLabelTF(stf);
        }

        btn.isOn = false;
        return btn;
    }

    public hide(){
        super.hide();
        if (this.selectedText) {
            this.selectedText.visible = false;
        }
    }

    public show(){
        super.show();
        if (this.selectedText) {
            this.selectedText.visible = true;
        }
    }

    public isSelected() {
        return this.isOn;
    }

    public addSelectedLabelTF(tf: TextField, bounds?: IObjectConfig)
    { 
        if (!bounds) {
            let settings = {
                "scaleX": App.config.labelSettings?.scaleX || 0.8,
                "scaleY": App.config.labelSettings?.scaleY || 0.8,
                "offsetX": App.config.labelSettings?.offsetX || 0,
                "offsetY": App.config.labelSettings?.offsetY || 0
            }

            const width = Layout.getWidth(this.butImg) * settings.scaleX;
            const height = Layout.getHeight(this.butImg) * settings.scaleY;
            bounds = {
                x: Layout.getX(this.butImg) + settings.offsetX * width,
                y: Layout.getY(this.butImg) + settings.offsetY * height,
                width: width,
                height: height
            };
            tf.anchor.set(this.butImg.anchor.x, this.butImg.anchor.y);
            tf.boundAnchor = {x: (0.5 - this.butImg.anchor.x), y:  (0.5 - this.butImg.anchor.y)};
        }
        tf.bound = bounds;
        tf.applyBound();
        this.addChild(tf);
        this.selectedText = tf;
        this.selectedText.alpha = this.isOn ? 1 : 0;
    }

    public setSelectedSkins(skin: IButtonSkin)
    {
        this.selectedSkinMap =
        {
            "UP" : skin.up,
            "OVER" : skin.over || skin.up,
            "DOWN" : skin.down || skin.up,
            "DISABLED" : skin.off || skin.up
        };

        this.stateUpdated();
    }

    protected stateUpdated()
    {
        // const skinMap = this.isOn ? this.selectedSkinMap : this.skinMap;
        this.butImg.texture = this.getSkin();

        if (this.animateScale)
        {
            const scale = 1 + Number(!this.over) * .25;
            Tween.to(this.butImg.scale, .075, {x: scale, y: scale, overwrite: true});
        }
    }

    getSkin(): Texture{
        const skinMap = this.isOn ? this.selectedSkinMap : this.skinMap;
        let texture = this.assets.getTexture(skinMap[this.state]);
        if(!texture) {
            texture = this.assets.getTexture(skinMap["UP"]);
        }

        return texture;
    }

    public toggle() {
        this.switch(!this.isOn);
    }

    public switch(on: boolean) {
        if (on) {
            this.switchOn();
        } else {
            this.switchOff();
        }
    }

    private switchOn() {
        if (this.isOn) {
            return;
        }

        this.butImg.visible = true;
        this.isOn = true;

        if (this.selectedText) {
            this.selectedText.alpha = 1;
            if (this.text) {
                this.text.alpha = 0;
            }
        }
        this.stateUpdated();
    }

    private switchOff() {
        if (!this.isOn) {
            return;
        }


        this.butImg.visible = true;
        this.isOn = false;
        if (this.selectedText) {
            this.selectedText.alpha = 0;
            if (this.text) {
                this.text.alpha = 1;
            }
        }
        this.stateUpdated();
    }

    public setValue(value: string,formatedValue?:string) {
        this._value = value;
        if (this.text ) {
            this.text.text = formatedValue || value;
        }

        if (this.selectedText ) {
            this.selectedText.text = formatedValue || value;
        }
    }

    public setSound(sndId: string, offStateSoundId?: string) {
        super.setSound(sndId);
        this.offStateSoundId = offStateSoundId;
    }

    protected playInteractionSound() {
        if (!this.isOn && this.offStateSoundId) {
            SoundController.playSound(this.offStateSoundId);
        } else {
            super.playInteractionSound();
        }
    }

    
    public get data(){
        return { 
            value:this.isOn
        }
    }

}

